import { render, staticRenderFns } from "./CollectionSwitcherMenu.vue?vue&type=template&id=4c08aae2"
import script from "./CollectionSwitcherMenu.vue?vue&type=script&lang=js"
export * from "./CollectionSwitcherMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports